<template>
  <div id="OrderPage" class="pb-8 animate-page">
    <min-nav></min-nav>
    <page-header title="طلبات الصيانة" icon="fas fa-wrench"></page-header>

    <!-- ── Edit Order Modal ── -->
    <div :class="[editStatus ? 'active' : '', 'edit-form']">
      <div class="bg-white rounded-2xl p-6 w-full max-w-2xl max-h-screen overflow-y-auto"
           style="box-shadow:0 25px 60px -15px rgba(0,0,0,.22); animation: scaleIn .35s cubic-bezier(.16,1,.3,1) both;">
        <div class="flex items-center justify-between mb-5">
          <h3 class="font-bold text-dark-2 text-lg flex items-center gap-2">
            <span class="w-8 h-8 rounded-lg flex items-center justify-center text-sm"
                  style="background:rgba(59,130,246,.12);color:#3b82f6;">
              <i class="fas fa-pencil-alt"></i>
            </span>
            تعديل الطلب
          </h3>
          <button @click.prevent="toggleEditStatus()"
                  class="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-600 duration-200">
            <i class="fas fa-times text-sm"></i>
          </button>
        </div>
        <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
          <div class="input"><label>أسم السائق</label><input type="text" placeholder="أسم السائق" v-model="editData.driver_name" class="field" /></div>
          <div class="input"><label class="requier">رقم الهاتف</label><input type="text" placeholder="رقم الهاتف" v-model="editData.driver_phone" class="field" /></div>
          <div class="input"><label class="requier">نوع السيارة</label><input type="text" placeholder="نوع السيارة" v-model="editData.car_name" class="field" /></div>
          <div class="input"><label class="requier">رقم السيارة</label><input type="text" placeholder="رقم السيارة" v-model="editData.vehicle_no" class="field" /></div>
          <div class="input"><label class="requier">لون السيارة</label><input type="text" placeholder="لون السيارة" v-model="editData.color" class="field" /></div>
          <div class="input"><label class="requier">موديل السيارة</label><input type="text" placeholder="موديل السيارة" v-model="editData.model" class="field" /></div>
          <div class="input"><label class="requier">السعر</label><input type="text" placeholder="السعر" v-model="editData.price" class="field" /></div>
          <div class="input">
            <label class="requier">اختيار الموظف</label>
            <select v-model="editData.worker_id" class="field">
              <option :value="item.id" v-for="(item, index) in employees.data" :key="index">{{ item.name }}</option>
            </select>
          </div>
          <div class="input col-span-full">
            <label class="requier">الملاحظات</label>
            <textarea rows="3" placeholder="الملاحظات" v-model="editData.notes" class="field"></textarea>
          </div>
        </div>
        <div class="flex justify-end gap-2 mt-5 pt-4 border-t border-gray-100">
          <button class="btn sub-btn text-sm py-2 px-4" @click.prevent="toggleEditStatus()">إلغاء</button>
          <button :class="[postLoader ? 'opacity-60 cursor-not-allowed' : '', 'btn main-btn text-sm py-2 px-4']"
                  :disabled="postLoader" @click="edit_item()">
            <i class="fas fa-save ml-1"></i> حفظ التعديل
          </button>
        </div>
      </div>
    </div>

    <!-- ── Add New Order Card ── -->
    <div v-if="chackOwner || checkRole(['store-Maintenance-Order'])"
         id="add-form"
         class="w-11/12 mx-auto -mt-6 mb-4 bg-white rounded-2xl overflow-hidden"
         style="box-shadow:0 4px 20px -4px rgba(0,0,0,.1);">

      <!-- Card Header -->
      <div class="px-5 py-3 flex items-center justify-between border-b border-gray-100"
           style="background:linear-gradient(135deg,#f8fafc,#f1f5f9);">
        <div class="flex items-center gap-2">
          <span class="w-7 h-7 rounded-lg flex items-center justify-center text-xs"
                style="background:linear-gradient(135deg,#10b981,#059669);color:#fff;">
            <i class="fas fa-plus"></i>
          </span>
          <span class="font-bold text-dark-2 text-sm">إضافة طلب جديد</span>
        </div>
        <span class="text-xs text-muted">يرجى تعبئة الحقول المطلوبة</span>
      </div>

      <!-- Form Body -->
      <div class="px-5 py-4">
        <form action="" class="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-x-3 gap-y-3">

          <div class="input">
            <label>أسم السائق</label>
            <input type="text" placeholder="أسم السائق" v-model="postData.driver_name" class="field compact-field" />
          </div>

          <div class="input">
            <label class="requier">رقم الهاتف</label>
            <input type="text" placeholder="رقم الهاتف" v-model="postData.driver_phone" class="field compact-field" />
          </div>

          <div class="input">
            <label class="requier">نوع السيارة</label>
            <input type="text" placeholder="نوع السيارة" v-model="postData.car_name" class="field compact-field" />
          </div>

          <div class="input">
            <label class="requier">رقم السيارة</label>
            <input type="text" placeholder="رقم السيارة" v-model="postData.vehicle_no" class="field compact-field" />
          </div>

          <div class="input">
            <label class="requier">لون السيارة</label>
            <input type="text" placeholder="لون السيارة" v-model="postData.color" class="field compact-field" />
          </div>

          <div class="input">
            <label class="requier">موديل السيارة</label>
            <input type="text" placeholder="موديل السيارة" v-model="postData.model" class="field compact-field" />
          </div>

          <div class="input">
            <label class="requier">قسم الفحص</label>
            <select v-model="postData.department_id" class="field compact-field">
              <option value="" selected disabled>القسم</option>
              <option v-for="(item, index) in departments.data" :value="item.id" :key="index">{{ item.ar_name }}</option>
            </select>
          </div>

          <div class="input">
            <label class="requier">السعر</label>
            <input type="text" placeholder="السعر" v-model="postData.price" class="field compact-field" />
          </div>

          <div class="input">
            <label class="requier">اختيار الموظف</label>
            <select v-model="postData.worker_id" class="field compact-field">
              <option :value="item.id" v-for="(item, index) in employees.data" :key="index">{{ item.name }}</option>
            </select>
          </div>

          <div class="input col-span-full">
            <label>الملاحظات</label>
            <textarea rows="2" placeholder="الملاحظات" v-model="postData.notes" class="field compact-field"></textarea>
          </div>

          <div class="col-span-full flex justify-end pt-1">
            <button :class="[postLoader ? 'opacity-60 cursor-not-allowed' : '', 'btn main-btn text-sm py-2 px-5']"
                    :disabled="postLoader" @click.prevent="add_new_item()">
              <i class="fas fa-plus ml-1"></i>
              إضافة الطلب
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- ── Orders List ── -->
    <div class="list-form w-11/12 mx-auto" id="list-form">
      <div class="container">
        <!-- List Header -->
        <div class="section-title border-b border-gray-100 pb-3 mb-3">
          <div class="flex items-center gap-2">
            <span class="w-7 h-7 rounded-lg flex items-center justify-center text-xs"
                  style="background:linear-gradient(135deg,#0f172a,#1e293b);color:#fff;">
              <i class="fas fa-list text-xs"></i>
            </span>
            <span class="font-bold text-dark-2">قائمة الطلبات</span>
          </div>
          <div class="flex items-center gap-2 text-sm text-muted">
            <span>عدد العناصر</span>
            <select v-model="filterData.take" class="bg-surface-2 px-2 py-1 rounded-lg outline-none text-dark-2 text-xs border border-gray-100 cursor-pointer"
                    @change="filtering">
              <option :value="2">2</option>
              <option :value="15">15</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="500">500</option>
            </select>
          </div>
        </div>

        <!-- Filters -->
        <div class="filters">
          <div class="input">
            <input type="search" @change="filtering()" placeholder="🔍 اسم السائق" class="field compact-field" v-model="filterData.name" />
          </div>
          <div class="input">
            <input type="search" @change="filtering()" placeholder="🔍 رقم السيارة" class="field compact-field" v-model="filterData.vehicle_no" />
          </div>
          <div class="input">
            <date-picker @change="filtering()" v-model="filterData.created_at" valueType="format"></date-picker>
          </div>
        </div>

        <!-- Table -->
        <div class="list relative py-3">
          <get-loader v-if="!chassis_result_count && !chassis_filter && !postData.chassis_no"
                      class="absolute inset-0"></get-loader>
          <data-table :fields="fields" :data="orders.data" :actions="false">
            <template v-slot:order_no="{ item }">
              <span class="font-mono text-xs font-bold text-dark-2">{{ item.order_no?.split("-")[4] }}</span>
            </template>
            <template v-slot:created_at="{ item }">
              <span class="text-xs text-muted">{{ getFormDate(item.created_at) }}</span>
            </template>
            <template v-slot:worker="{ item }">
              <span>{{ item.worker ? item.worker.name : "—" }}</span>
            </template>
            <template v-slot:department_id="{ item }">
              <span class="px-2.5 py-1 rounded-lg text-xs font-semibold inline-block bg-blue-50 text-blue-600 border border-blue-100">
                {{ MaintenanceOrderStatus(item.department_id) }}
              </span>
            </template>
            <template v-slot:updated_at="{ item }">
              <span class="text-xs text-muted">{{ getFormDate(item.updated_at) }}</span>
            </template>
            <template v-slot:status="{ item }">
              <span v-if="!item.status" class="px-2.5 py-1 rounded-lg text-xs font-semibold inline-block bg-amber-50 text-amber-600 border border-amber-100">
                قيد العمل
              </span>
              <span v-if="item.status == 1" class="px-2.5 py-1 rounded-lg text-xs font-semibold inline-block bg-emerald-50 text-emerald-600 border border-emerald-100">
                مكتمل
              </span>
            </template>
            <template v-slot:actions="{ item }">
              <ul class="actions-list">
                <li @click="add_img_form(item.id)" aria-label="اضافة صور"
                    class="hover:text-blue-500 hover:border-blue-200 hint--top">
                  <i class="fas fa-file-image"></i>
                </li>
                <li v-if="checkRole(['update-Maintenance-Order'])" aria-label="تعديل الطلب"
                    class="hover:text-blue-500 hover:border-blue-200 hint--top"
                    @click="editInit(item)">
                  <i class="fas fa-pencil-alt"></i>
                </li>
                <li v-if="checkRole(['update-Maintenance-Order'])" aria-label="أكمال الطلب"
                    class="hover:text-emerald-500 hover:border-emerald-200 hint--top"
                    @click="complete_order(item)">
                  <i class="fas fa-clipboard-check"></i>
                </li>
                <li v-if="checkRole(['update-user'])" aria-label="الغاء الطلب"
                    class="hover:text-red-500 hover:border-red-200 hint--top"
                    @click="delete_order(item)">
                  <i class="fas fa-times"></i>
                </li>
              </ul>
            </template>
          </data-table>
        </div>
      </div>
    </div>

    <!-- ── Pagination ── -->
    <div class="w-11/12 mx-auto py-4 bg-white rounded-2xl mt-3 shadow-card"
         v-if="orders.total > filterData.take">
      <div class="container flex items-center justify-center">
        <v-pagination v-model="currentPage" :records="orders.total" :per-page="filterData.take" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.compact-field {
  padding-top: 0.45rem !important;
  padding-bottom: 0.45rem !important;
  font-size: 0.8rem !important;
}
</style>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import $http from "@/plugins/axios.js";
export default {
  /* eslint-disable */
  components: { DatePicker },
  data() {
    return {
      currentPage: 1,
      changeStatusInit: false,
      filterOrderStatusvalue: "",
      carTypes: ["Kia", "Hunday", "Tayouta"],
      postData: {
        driver_name: "",
        driver_phone: "",
        car_no: "",
        car_type: "",
        car_color: "",
        car_body_type: "",
        car_model: "",
        sanoia_no: "",
        chassis_no: "",
        speedometer: "",
        price: "",
        discount: 0,
        status: "",
        worker_id: "",
      },
      changeStatusValue: {
        status: "",
      },
      editData: {},
      tempData: {},
      filterData: {
        take: 15,
        page: 1,
        name: "",
        vehicle_no: "",
        chassis_no: "",
        sanoia_no: "",
        created_at: "",
      },
      chassis_filter: false,
      chassis_result_count: 0,
    };
  },
  computed: {
    fields() {
      return [
        { title: "أسم السائق",  key: "driver_name" },
        { title: "رقم السائق", key: "driver_phone" },
        { title: "نوع السيارة", key: "car_name" },
        { title: "لون السيارة", key: "color" },
        { title: "رقم السيارة", key: "vehicle_no" },
        { title: "السعر",       key: "price" },
        { title: "اسم العامل",  key: "worker" },
        { title: "الحالة",      key: "status" },
        { title: "تاريخ",       key: "created_at" },
        { title: "قسم الفحص",   key: "department_id" },
        { title: "تعديل",       key: "actions" },
      ];
    },
    chackOwner() {
      return this.getUserRole == "Owner";
    },
  },
  watch: {
    currentPage(value) {
      this.filterData.page = value;
      this.getMaintenanceOrders(this.filterData);
    },
  },
  methods: {
    filtering() {
      this.getMaintenanceOrders(this.filterData);
    },
    filteringChassie() {
      $http
        .get(`/orders-today?filter[chassis_no]=${this.postData.chassis_no}&take=1000`)
        .then((res) => {
          this.chassis_result_count = res.data.total;
          this.chassis_filter = true;
        });
    },
    filterOrderStatus() {
      if (this.filterOrderStatusvalue == "") {
        this.getMaintenanceOrders();
      }
    },
    add_new_item() {
      this.createMaintenanceOrder(this.postData).then(() => {
        this.postData = {
          driver_name: "",
          driver_phone: "",
          vehicle_no: "",
          car_name: "",
          color: "",
          model: "",
          price: "",
          notes: "",
          department_id: 1,
        };
      });
      this.orders.data = [];
      this.getMaintenanceOrders();
    },
    editInit(item) {
      this.toggleEditStatus();
      Object.assign(this.editData, item);
      this.editData._method = "PUT";
    },
    edit_item() {
      delete this.editData.last_login;
      this.updateMaintenanceOrder(this.editData).then(() => {
        this.toggleEditStatus();
        this.getMaintenanceOrders();
      });
    },
    add_img_form(id) {
      this.$router.push(`/maintenance_orders_image/${id}`);
    },
    delete_order(item) {
      this.confirmDelete(() => {
        this.deleteOrder(item.id);
      });
    },
    complete_order(item) {
      this.confirmComplete(() => {
        this.completeMaintenanceOrder(item.id).then(() =>
          this.getMaintenanceOrders(this.filterData)
        );
      });
    },
    showChangeStatus(item) {
      this.changeStatusInit = true;
      this.changeStatusValue.order_id = item.id;
    },
    changeStatusData() {
      this.changeStatusOrder({
        order_id: this.changeStatusValue.order_id,
        data: this.dataReutrn({
          status: this.changeStatusValue.status,
          _method: "PUT",
        }),
      }).then(() => {
        this.changeStatusInit = false;
        this.getMaintenanceOrders();
      });
    },
  },
  mounted() {
    this.getMaintenanceOrders();
    this.getDepartments();
    this.getEmployees();
    document.querySelectorAll("#OrderPage .field").forEach((el) => {
      el.addEventListener("input", () => {
        el.value.length !== 0 ? el.classList.add("filled") : el.classList.remove("filled");
      });
    });
  },
};
</script>
